export const WEB_API = 'https://34maua2r97.execute-api.ap-southeast-1.amazonaws.com/prod/api/';
//export const WEB_API = 'http://122.155.0.74:2344/api';
export const AUTH_KEY = 'uG5dnTK6cj8n676eB7XDv1P91ml9BsTp2Osv8wAw';